import script from "./OverlayItem.vue?vue&type=script&setup=true&lang=js"
export * from "./OverlayItem.vue?vue&type=script&setup=true&lang=js"

import "./OverlayItem.vue?vue&type=style&index=0&id=82c4b16a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82c4b16a"]])

export default __exports__